import { createContext, ReactNode, useContext, useMemo } from "react";

import { DockPanelKeyContext } from "~/providers/DockPanelContext";
import { SidePanelContextType, SidePanelRegistry } from "~/providers/SidePanelTypes";

const SidePanelContext = createContext<SidePanelRegistry>({
	clearPanelContent: () => {},
	setDefaultPanelWidth: () => {},
	setMobileViewportScroll: () => {},
	setPanelContent: () => {}
});

export const useSidePanel = (): SidePanelContextType => {
	const { clearPanelContent, setDefaultPanelWidth, setMobileViewportScroll, setPanelContent } =
		useContext(SidePanelContext);
	const panelKey = useContext(DockPanelKeyContext);

	return useMemo(
		() => ({
			clearSidePanelContent: () => clearPanelContent(panelKey),
			setDefaultPanelWidth,
			setMobileViewportScroll,
			setSidePanelContent: (content: ReactNode) => setPanelContent(panelKey, content)
		}),
		[clearPanelContent, panelKey, setDefaultPanelWidth, setMobileViewportScroll, setPanelContent]
	);
};

export default SidePanelContext;
